import type { Language, Timezone } from "~/api/tills/types";

import { DEFAULT_LANGUAGE, DEFAULT_TIMEZONE } from "./constants";

type TimeFormatterArgs = {
  timestamp: number;
  language?: Language | null;
  timezone?: Timezone | null;
};

export function timeFormatter({
  timestamp,
  language,
  timezone
}: TimeFormatterArgs): string {
  const ts = timestamp < 1e12 ? timestamp * 1000 : timestamp;

  return new Intl.DateTimeFormat(language ?? DEFAULT_LANGUAGE, {
    hour: "numeric",
    minute: "numeric",
    timeZone: timezone ?? DEFAULT_TIMEZONE
  }).format(new Date(ts));
}
